<h1 mat-dialog-title [attr.data-cy]="'ggdgd_h1_1'">Rindergruppe erstellen</h1>
<div mat-dialog-content>
    <p style="width: 100%" [attr.data-cy]="'ggdgd_p_1'">
        {{ input?.kunde?.bezeichnung_final }} {{ input?.kunde?.zusatz_final }}
    </p>

    <mat-checkbox *ngIf="sgsEinblenden" [formControl]="sgsMeldenCtrl" [attr.data-cy]="'ggdgd_mat-checkbox_1'"
        >An SGS melden
    </mat-checkbox>

    <mat-form-field style="width: 100%" [attr.data-cy]="'ggdgd_mat-form-field_1'">
        <mat-label>Produktionsabschnitt</mat-label>
        <mat-select [formControl]="produktionsabschnittCtrl" [compareWith]="produktionsabschnittComparator">
            <mat-option
                *ngFor="let p of produktionsabschnitte; let i = index"
                [value]="p"
                [attr.data-cy]="'ggdgd_mat-option_' + i"
            >
                {{ p.produktionsabschnitt }}
            </mat-option>
        </mat-select>
    </mat-form-field>

    <kiene-autocomplete
        *ngIf="input?.kunde"
        #standortAutocomplete
        (deleteSelected)="deleteStall($event)"
        (elementSelected)="setStandort($event)"
        [displayFields]="['stall', 'sgs_nummer']"
        separator=", "
        [emitFreeText]="true"
        [focus]="true"
        [genericApiUrl]="'gruppe/read_stall.php'"
        [kieneObject]="standort"
        [params]="standortParams"
        [placeholder]="'Stall'"
        [showClear]="false"
        [showDeleteButton]="true"
    >
    </kiene-autocomplete>

    <mat-form-field *ngIf="sgsNummerEinblenden" style="width: 100%" [attr.data-cy]="'ggdgd_mat-form-field_2'">
        <mat-label>SGS Nummer</mat-label>
        <input [formControl]="sgsNummerCtrl" matInput type="text" [attr.data-cy]="'ggdgd_input_1'" />
    </mat-form-field>

    <mat-form-field style="width: 100%" [attr.data-cy]="'ggdgd_mat-form-field_3'">
        <mat-label>Gruppenname</mat-label>
        <input [formControl]="gruppennameCtrl" matInput type="text" [attr.data-cy]="'ggdgd_input_2'" />
    </mat-form-field>

    <mat-form-field
        *ngIf="KieneUtils.isApiOne(input?.kunde?.kaelbermast)"
        style="width: 100%"
        [attr.data-cy]="'ggdgd_mat-form-field_4'"
    >
        <mat-label>Aufstalleinheit</mat-label>
        <div class="one-row">
            <input
                [formControl]="aufstalleinheitJahrCtrl"
                matInput
                max="99"
                maxlength="2"
                min="1"
                style="width: 40px; margin-right: 12px; border: 1px solid lightgray; padding: 4px; border-radius: 4px"
                type="number"
                [attr.data-cy]="'ggdgd_input_3'"
            />
            <span>- AE -</span>
            <input
                [formControl]="aufstalleinheitNummerCtrl"
                matInput
                style="width: 60px; margin-right: 12px; border: 1px solid lightgray; padding: 4px; border-radius: 4px"
                type="number"
                [attr.data-cy]="'ggdgd_input_4'"
            />
        </div>
    </mat-form-field>

    <div *ngIf="input?.einstalldatumAusblenden === false" class="one-row">
        <mat-form-field style="width: 45%" [attr.data-cy]="'ggdgd_mat-form-field_5'">
            <mat-label>Einstalldatum von</mat-label>
            <input
                [formControl]="einstalldatumVonCtrl"
                [matDatepicker]="einstalldatum_von"
                [readonly]="true"
                matInput
                [attr.data-cy]="'ggdgd_input_5'"
            />
            <mat-datepicker-toggle [for]="einstalldatum_von" matSuffix></mat-datepicker-toggle>
            <mat-datepicker #einstalldatum_von></mat-datepicker>
        </mat-form-field>

        <mat-form-field style="width: 45%" [attr.data-cy]="'ggdgd_mat-form-field_6'">
            <mat-label>Einstalldatum bis</mat-label>
            <input
                [formControl]="einstalldatumBisCtrl"
                [matDatepicker]="einstalldatum_bis"
                [readonly]="true"
                matInput
                [attr.data-cy]="'ggdgd_input_6'"
            />
            <mat-datepicker-toggle [for]="einstalldatum_bis" matSuffix></mat-datepicker-toggle>
            <mat-datepicker #einstalldatum_bis></mat-datepicker>
        </mat-form-field>
    </div>

    <ng-container *ngIf="KieneUtils.isApiOne(input?.kunde?.schwein)">
        <div *ngIf="KieneUtils.isApiZero(input?.kunde?.tierbewegung_melden)">
            <mat-form-field style="margin-right: 12px" [attr.data-cy]="'ggdgd_mat-form-field_7'">
                <mat-label>Anzahl Tiere</mat-label>
                <input
                    [formControl]="anzahlTiereCtrl"
                    matInput
                    maxlength="15"
                    type="number"
                    [attr.data-cy]="'ggdgd_input_7'"
                />
            </mat-form-field>

            <mat-form-field style="margin-right: 12px" [attr.data-cy]="'ggdgd_mat-form-field_8'">
                <mat-label>Alter bei Einstallung (Tage)</mat-label>
                <input
                    [formControl]="alterEinstallungCtrl"
                    matInput
                    maxlength="15"
                    type="number"
                    [attr.data-cy]="'ggdgd_input_8'"
                />
            </mat-form-field>
        </div>
    </ng-container>
</div>
<div mat-dialog-actions>
    <span class="spacer"></span>
    <button (click)="close()" mat-button [attr.data-cy]="'ggdgd_button_1'">Abbrechen</button>
    <button
        (click)="save()"
        color="accent"
        mat-flat-button
        [disabled]="!isFormValid()"
        [attr.data-cy]="'ggdgd_button_2'"
    >
        Erstellen
    </button>
</div>
